"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomePricingMerchandiseOption = void 0;
const Pricing_1 = require("../entity/Pricing");
const pricingTable_1 = require("./pricingTable");
const createSomePricingMerchandiseOption = ({ id = '123456789', name = 'Option Name', displayToOptimizer = true, pricingTables = [pricingTable_1.createSomePricingTable()], } = {}) => new Pricing_1.PricingMerchandiseOption({
    id,
    name,
    displayToOptimizer,
    pricingTables,
});
exports.createSomePricingMerchandiseOption = createSomePricingMerchandiseOption;
